import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import InCountry from "../../Components/InCountry/InCountry";
import s from "./InRussia.module.scss";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import CountriesButtons from "../../Components/CountriesButtons/CountriesButtons";
import DiseaseButtons, {
  IDisease,
} from "../../Components/DiseaseButtons/DiseaseButtons";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getDiseaseList,
  getIamInRussia,
  getPreDepartureDiseasesList,
} from "../../redux/InformationSlice";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

const InRussia = () => {
  const dispatch: AppDispatch = useDispatch();
  const inRussiaInfo = useSelector(
    (state: RootState) => state.info.inRussiaInfo,
  );
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const diseaseList = useSelector((state: RootState) => state.info.diseaseList);
  const preDepartureDiseasesList = useSelector(
    (state: RootState) => state.info.preDepartureDiseasesList,
  );

  useEffect(() => {
    dispatch(getIamInRussia());
    dispatch(getDiseaseList());
    dispatch(getPreDepartureDiseasesList());
  }, []);

  const html = inRussiaInfo?.body_3 ?? "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const paragraphs = Array.from(doc.querySelectorAll("p"));

  // Делим абзацы пополам для двух колонок
  const mid = Math.ceil(paragraphs.length / 2);
  const leftColumn = paragraphs
    .slice(0, mid)
    .map((p) => p.outerHTML)
    .join("");
  const rightColumn = paragraphs
    .slice(mid)
    .map((p) => p.outerHTML)
    .join("");

  return (
    <div>
      <Seo
        title="Медосмотр для мигрантов"
        description="Обязательный медосмотр для работы в России: анализ на ВИЧ, туберкулёз, сифилис. Где и когда проходить, цена"
        url="https://www.vputi.org/russia"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <div className={s.inner}>
          <InCountry />
          <Navigation
            navigation={{
              name: "Главная / Законодательство России",
              path: "/",
            }}
          />
          <ContactButtons />
          <CountriesButtons />
          <div className={s.text_1}>
            <div className={s.image}>
              <img className={s.img} src={inRussiaInfo?.image} />
            </div>
            <div className={s.text_1_wrapper}>
              <div className={s.text_title}>{inRussiaInfo?.title_1}</div>
              <div
                dangerouslySetInnerHTML={{
                  __html: inRussiaInfo?.body_1 ?? "",
                }}
                className={s.decription}
              />
            </div>
          </div>
          <div className={s.text_2}>
            <div className={s.title_2}>{inRussiaInfo?.title_2}</div>
            <div
              className={s.description_2}
              dangerouslySetInnerHTML={{ __html: inRussiaInfo?.body_2 ?? "" }}
            ></div>
          </div>
          <div className={s.description_3}>
            <div className={s.columns}>
              <div dangerouslySetInnerHTML={{ __html: leftColumn }} />
              <div dangerouslySetInnerHTML={{ __html: rightColumn }} />
            </div>
          </div>
          <div
            className={s.yellow_wrapper}
            dangerouslySetInnerHTML={{ __html: inRussiaInfo?.body_4 ?? "" }}
          ></div>

          <div
            className={s.description_4}
            dangerouslySetInnerHTML={{ __html: inRussiaInfo?.body_5 ?? "" }}
          ></div>

          <DiseaseButtons
            diseases={diseaseList?.map((it) => ({
              id: it.id,
              button: it.button,
              button_ru: it.button,
              button_kg: it.button_ky,
              button_uz: it.button_uz,
              button_tj: it.button_tg,
            }))}
            country="russia"
          />
          <div className={s.title}>{t("Как подготовиться к отъезду")}</div>
          <DiseaseButtons
            diseases={[...(preDepartureDiseasesList || [])]
              .reverse()
              ?.map((it) => ({
                id: it.id,
                button: it.button,
                button_ru: it.button,
                button_kg: it.button_ky,
                button_uz: it.button_uz,
                button_tj: it.button_tg,
              }))}
            country="russia"
          />
          <div className={s.title}>
            {t("Где я могу пройти обследования на родине?")}
          </div>
          <CountriesBlueButtons />
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default InRussia;
